import { useDispatch } from 'react-redux';

import { setFile, deleteFile } from '../Firebase/Redux/Features/Storage/storageSlice';

// Subir y borrar en Storage con promesas (sin los Swal ni la navegación de useStorage), para encadenar
// subir la nueva → guardar en la API → borrar la anterior, en ese orden
const useImagenesStorage = () => {
    const dispatch = useDispatch();

    const subir = async (file, folder, name) => {
        const res = await dispatch(setFile({ file, name, folder }));
        if (res.meta.requestStatus !== 'fulfilled' || res.payload?.status === 'failed') return null;
        return res.payload;
    }

    const eliminar = async url => (await dispatch(deleteFile({ urlFile: url }))).payload === true;

    return { subir, eliminar };
};

export default useImagenesStorage;
